import React from 'react';
import { BookMarkedIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { includedItems } from '../data/included';
export function IncludedSection() {
  return <section aria-labelledby="included-title" className="bg-white px-5 py-20 md:py-28" data-id="element-140" data-mp="37g65xsaz5ns1">
      <Reveal className="mx-auto max-w-content" data-id="element-141" data-mp="3cdful5qjhvet">
        <h2 id="included-title" className="flex flex-wrap items-center justify-center gap-3 text-center text-3xl font-extrabold tracking-tight text-pine md:text-4xl" data-id="element-142" data-mp="3cgbtawa7oo4b">
          <BookMarkedIcon className="h-7 w-7 shrink-0 text-turquoise" strokeWidth={2} aria-hidden="true" data-id="element-143" data-mp="823rm8bz6103" />
          What&apos;s Inside LACROSSE READY 360™?
        </h2>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-144" data-mp="3vbscbfviodm0">
          {includedItems.map(({
          icon: ItemIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-card bg-cream p-7 shadow-card" data-id="element-145" data-mp="mvff1nn9ujsi">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-pine shadow-card" data-id="element-146" data-mp="rptfi4gsjh41">
                <ItemIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-147" data-mp="3mfslovy7xd2i" />
              </span>
              <h3 className="mt-5 text-lg font-bold leading-snug text-pine" data-id="element-148" data-mp="422v7smorcox">{title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-body" data-id="element-149" data-mp="3vggyxofsf9ec">{description}</p>
            </article>)}
        </div>
        <div className="mt-12 flex justify-center" data-id="element-150" data-mp="dye92n1xcalh">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-151" data-mp="90mgrrxdamgr" />
        </div>
      </Reveal>
    </section>;
}